import React from "react";
import { Redirect, Route, Switch } from "react-router";

import { InvoiceApproval } from "./invoiceApproval";
import { MonitoringRouter } from "./Monitoring";
import { MyAccount } from "./myAccount";
import { InvestmentRouter } from "./Investments";
import { AutomationRouter } from "./Automation";
import { NoAutomationPage } from "./Automation/NoAutomationPage";
import { BuildingsRouter } from "./Buldings";
import { BillingMain } from "./MyBills";

import { SectionWrapper } from "components/admin/SectionWrapper";
import { PasswordReset } from "./PasswordReset";
import { DecarbonizationMain } from "./Decarbonization";

export const AdminRouter = () => {
  return (
    <SectionWrapper>
      <Switch>
        <Route path="/admin/billing" component={BillingMain} />
        <Route path="/admin/invoice-approval" component={InvoiceApproval} />
        <Route path="/admin/monitoring" component={MonitoringRouter} />
        <Redirect from="/admin/carbon-footprint" to="/admin/decarbonization" />
        <Route path="/admin/decarbonization" component={DecarbonizationMain} />
        <Route path="/admin/my-account" component={MyAccount} />
        <Route path="/admin/password-reset" component={PasswordReset} />
        <Route path="/admin/investments" component={InvestmentRouter} />
        <Route path="/admin/buildings" component={BuildingsRouter} />
        <Route path="/admin/no-automation" component={NoAutomationPage} />
        <Route path="/admin/automation" component={AutomationRouter} />
      </Switch>
    </SectionWrapper>
  );
};
